import { refField } from "@tc/drizzle-v2"
import { eq } from "drizzle-orm"
import {
  SQSClient,
  SendMessageCommand,
  MessageAttributeValue,
} from "@aws-sdk/client-sqs"
import { DbTransaction } from "@tc/middy-decorators"
import { FieldDoc } from "../types/reference-data"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["FIELD_QUEUE_URL"]

export const getRefFieldData = async (
  tx: DbTransaction,
  id: string,
): Promise<FieldDoc | undefined> => {
  const [row] = await tx
    .select({
      fieldUniqueId: refField.fieldUniqueId,
      fieldName: refField.fieldName,
      dataType: refField.dataType,
      apTransferSection: refField.apTransferSection,
      apExportSection: refField.apExportSection,
      phytoExportSection: refField.phytoExportSection,
      userConfigurable: refField.userConfigurable,
      classificationCode: refField.classificationCode,
      classificationName: refField.classificationName,
      fieldCategory: refField.fieldCategory,
      defaultDisplayType: refField.defaultDisplayType,
      createdAt: refField.createdAt,
      createdBy: refField.createdBy,
      updatedAt: refField.updatedAt,
      updatedBy: refField.updatedBy,
    })
    .from(refField)
    .where(eq(refField.fieldUniqueId, id))

  if (!row) {
    console.error(`RefField with id ${id} not found`)
    return
  }

  const refFieldDoc: FieldDoc = {
    id: row.fieldUniqueId,
    field_name: row.fieldName,
    data_type: row.dataType,
    ap_transfer_section: row.apTransferSection,
    ap_export_section: row.apExportSection,
    phyto_export_section: row.phytoExportSection,
    user_configurable: row.userConfigurable,
    classification_code: row.classificationCode,
    classification_name: row.classificationName,
    field_category: row.fieldCategory,
    default_display_type: row.defaultDisplayType,
    created_at: row.createdAt.getTime(),
    created_by: row.createdBy,
    updated_at: row.updatedAt.getTime(),
    updated_by: row.updatedBy,
  }

  searchBuilderLog.debug({
    document: refFieldDoc,
  })

  return refFieldDoc
}

export const saveRefFieldToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getRefFieldData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
